import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA I TUOI ESERCIZI',
        description: 'Trovi gli esercizi che hai modificato nel tempo dal più recente in poi.',
        name: 'UserExercisesSearchForm',
        tutorialName: 'crea-verifica_tab-miei-esercizi'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 3
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'MIDDLE',
        xOffset: 10
    }
};
